<template>
  <FourElement />
  <div class="collection-container" :class="{ 'is-readonly': disabled }">
    <div v-if="langList.length" class="mb20">
      <a-tabs v-model:activeKey="langCode" @change="handleLangChange">
        <a-tab-pane
          v-for="item in langList"
          :key="item.value"
          :tab="item.label"
        ></a-tab-pane>
      </a-tabs>
    </div>
    <div class="df">
      <div class="w200 tar h30 lh30">
        <span class="red">*</span>倒计时获取方式：
      </div>
      <div>
        <a-select
          v-model:value="params.countdownType"
          style="min-width: 150px"
          @focus="focus"
          @change="handleTypeChange"
          :disabled="disabled"
        >
          <a-select-option :value="1">自定义倒计时</a-select-option>
          <a-select-option :value="2">读取优惠券</a-select-option>
          <a-select-option :value="3">秒杀</a-select-option>
        </a-select>
      </div>
    </div>
    <div
      class="df"
      v-if="params.countdownType !== 2 && params.countdownType !== 3"
    >
      <div class="w200 tar h30 lh30">
        <span class="red">*</span>活动起止时间：
      </div>
      <div>
        <a-range-picker
          style="min-width: 220px"
          @change="e => changeFilterTime(e)"
          v-model:value="params.timeSet"
          show-time
          :placeholder="['开始时间', '结束时间']"
          :disabled="disabled"
        />
      </div>
    </div>
    <div class="df" v-if="params.countdownType === 2">
      <div class="w200 tar h30 lh30">
        <span class="red">*</span>优惠劵CODE码：
      </div>
      <div>
        <a-input
          v-model:value="params.couponCode"
          placeholder="请输入"
          :disabled="disabled"
        />
      </div>
    </div>
    <div class="fs12 ml60" style="color: #666;">（备注：请输入GMT+1）</div>
    <div class="df">
      <div class="w200 tar h30 lh30"><span class="red">*</span>活动标题：</div>
      <div>
        <a-input v-model:value="langData.title" placeholder="请输入" />
      </div>
    </div>
    <div class="df">
      <div class="w200 tar h30 lh30">标题色值：</div>
      <div class="color-picker-wrap">
        <ColorPicker
          format="hex6"
          v-model:pureColor="params.titleColor"
          :disabled="disabled"
        />
      </div>
    </div>
    <div class="df">
      <div class="w200 tar h30 lh30">
        <span class="red">*</span>倒计时文案：
      </div>
      <div>
        <a-input
          v-model:value="langData.toEndCopywriting"
          placeholder="请输入"
        />
      </div>
    </div>
    <div class="df">
      <div class="w200 tar h30 lh30">
        倒计时文案色值（黑/白）：
      </div>
      <div class="color-picker-wrap">
        <ColorPicker
          :disabled="disabled"
          format="hex6"
          v-model:pureColor="params.countdownCopywritingColor"
        />
      </div>
    </div>
    <div class="df">
      <div class="w200 tar h30 lh30">
        倒计时时间色值（黑/白）：
      </div>
      <div class="color-picker-wrap">
        <ColorPicker
          :disabled="disabled"
          format="hex6"
          v-model:pureColor="params.countdownColor"
        />
      </div>
    </div>
    <div class="df">
      <div class="w200 tar h30 lh30">
        倒计时背景色值（黑/白）：
      </div>
      <div class="color-picker-wrap">
        <ColorPicker
          :disabled="disabled"
          format="hex6"
          v-model:pureColor="params.countdownBakColor"
        />
      </div>
    </div>
    <div class="df">
      <div class="w200 tar h30 lh30">
        背景图片色：
      </div>
      <div class="color-picker-wrap">
        <ColorPicker
          :disabled="disabled"
          format="hex6"
          v-model:pureColor="params.bakPictureColor"
        />
      </div>
    </div>
    <div class="df">
      <div class="w200 tar"><span class="red">*</span>活动图片：</div>
      <div class="w80 h80 mb10 pr subscription">
        <a-upload-dragger
          :fileList="[]"
          :show-upload-list="false"
          name="file"
          :multiple="true"
          :customRequest="e => upload(e, index)"
          :accept="'.png,.jpg,.jpeg,.gif'"
          :headers="uploadHeaders"
        >
          <div v-if="['', null].includes(langData.imageUrl)">
            <div
              class="w80 h80 tac"
              style="color: #999999; font-size: 40px; line-height: 80px;"
            >
              <PictureOutlined />
            </div>
          </div>
        </a-upload-dragger>
        <div
          v-if="!['', null].includes(langData.imageUrl)"
          class="h80 pa l0 t0 sidebarContentBg"
          :style="
            `width: 80px; background: url('${langData.imageUrl}') center center/ cover no-repeat;`
          "
        >
          <div class="hover">
            <EyeOutlined
              @click="() => changeVisiblePic(true, langData.imageUrl)"
            />
            &nbsp;&nbsp;
            <DeleteOutlined @click="langData.imageUrl = null" />
          </div>
        </div>
      </div>
      &nbsp;&nbsp;（请上传80*30透明底图）
    </div>
    <div class="df">
      <div class="w500 ml20 fs12">
        备注：当倒计时超过&nbsp;&nbsp;<a-input-number
          id="inputNumber"
          v-model:value="params.displayTime"
          :min="1"
        />&nbsp;&nbsp;小时不显示（不得大于99小时，默认72小时）
      </div>
    </div>
    <div>
      <a-popconfirm
        :title="'确认保存'"
        ok-text="确认"
        cancel-text="取消"
        @confirm="() => save()"
      >
        <a-button type="primary" class="ml300">保存</a-button>
      </a-popconfirm>
    </div>
    <a-modal
      :visible="visiblePic"
      :footer="null"
      @cancel="handleVisiblePicClose"
    >
      <img
        alt="example"
        style="width: 100%"
        :src="langData.imageUrl"
        class="preview-img"
      />
    </a-modal>
  </div>
</template>
<script>
import {
  PictureOutlined,
  EyeOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
import { formRequest } from 'cupshe-axios'
import { toRefs, reactive, provide, onMounted, watch } from 'vue'
import dayjs from 'dayjs'
import { useRouter, useRoute } from 'vue-router'
import FourElement from './components/FourElement'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
import { ColorPicker } from '@cupshe/vue3-colorpicker'
import { common_lang_get } from '@/server/modules/3426.js'
const {
  common_querySiteInfo_get_,
  pdpCountdown_add_post_,
  pdpCountdown_detail_post_
} = useAPI(null, [3426, 9832])
export default {
  components: {
    FourElement,
    PictureOutlined,
    EyeOutlined,
    DeleteOutlined,
    ColorPicker
  },
  setup() {
    const state = reactive({
      visiblePic: false,
      disabled: false,
      defaultLang: null,
      langCode: null,
      langData: {},
      langList: [],
      langs: [],
      brands: [],
      channels: [],
      sites: [],
      postParams: {},
      formatDate: 'YYYY-MM-DD HH:mm:ss',
      params: {
        timeSet: new Date(),
        token: null, //用户Token
        bakPictureColor: '#000000', // countdownColor背景图片色值
        brandId: 1, //品牌Id
        channelId: 1, //渠道Id
        titleColor: '#ffffff', // titleColor标题色值
        countdownCopywritingColor: '#000000', // countdownCopywritingColor倒计时文案色值
        countdownColor: '#ffffff', //countdownColor倒计时时间色值
        countdownBakColor: '#000000', //countdownColor倒计时背景色值
        countdownType: 0, // 倒计时类型。0-不对客，1-自定义倒计时，2-读取优惠券， 3-秒杀
        couponCode: '', //优惠券编码
        currency: null, // 币种
        displayTime: new Date(), // 倒计时显示限制
        endTime: new Date(), //	活动结束时间
        id: null, // 倒计时配置id
        imageUrl: '', // imageUrl活动图片url
        lang: '',
        langCode: '',
        siteId: 1,
        startTime: new Date(), //活动开始时间
        terminalId: 1,
        title: '', //	标题
        toEndCopywriting: '' //toEndCopywriting距结束文案
      },
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      getLang: async function() {
        let params = { ...state.searchParams }
        const { success, data, retInfo } = await common_lang_get({
          ...params
        })
        if (success) {
          const { languageMap } = data
          let langList = []
          for (let [label, value] of Object.entries(languageMap || [])) {
            langList.push({ value, label })
          }
          if (langList) {
            state.langList = langList

            const langCode = langList[0].value
            state.langCode = langCode
            state.defaultLang = langCode
          }
          state.getDetail()
        } else {
          message.error(retInfo)
        }
      },
      getDetail: async () => {
        await pdpCountdown_detail_post_(state)
        state.setLangData()
        const { startTime, endTime } = state.params
        state.params.timeSet = [
          startTime ? dayjs(startTime, state.formatDate) : null,
          endTime ? dayjs(endTime, state.formatDate) : null
        ]
        state.params.displayTime = state.params.displayTime || 72
        state.params.countdownType = state.params.countdownType || 1
        state.params.titleColor = state.params.titleColor || '#ffffff'
        state.params.countdownColor = state.params.countdownColor || '#ffffff'
      },
      setLangData: () => {
        const dataSource = state.langs.find(
          item => item.langCode === state.langCode
        )
        state.langData = dataSource
      },
      handleLangChange: (langCode = '') => {
        state.langCode = langCode

        const disabled = state.defaultLang !== state.langCode
        if (state.disabled !== disabled) {
          state.disabled = disabled
        }
        state.setLangData()
      },
      save: () => {
        const { langData = {}, params = {} } = state
        const {
          countdownType,
          couponCode,
          startTime,
          endTime,
          countdownBakColor,
          countdownColor,
          displayTime
        } = params

        if (Object.keys(langData).length) {
          const { title, toEndCopywriting, imageUrl } = langData
          if (countdownType === 2) {
            if (!couponCode) {
              message.warning('优惠劵CODE码未设置！')
              return
            }
          } else if (countdownType !== 3) {
            if (!startTime || !endTime) {
              message.warning('活动起止时间未设置！')
              return
            }
            if (startTime === endTime) {
              message.warning('活动起止时间不可相同')
              return
            }
          }
          if (!title) {
            message.warning('活动标题未填写!')
            return
          }
          if (!toEndCopywriting) {
            message.warning('倒计时文案未填写!')
            return
          }
          if (!imageUrl) {
            message.warning('活动图片未上传!')
            return
          }
          if (countdownBakColor === countdownColor) {
            message.warning('倒计时时间与背景颜色不可相同!')
            return
          }
          if (displayTime > 99) {
            message.warning('倒计时时间超过上限!')
            return
          }
        }
        let postParams = {
          ...state.params,
          ...state.searchParams,
          langs: state.langs,
          langCode: state.langCode
        }
        pdpCountdown_add_post_(postParams)
      },
      handleTypeChange() {
        state.params.countdownType === 2
          ? (state.params.timeSet = null)
          : (state.params.couponCode = '')
      },
      changeFilterTime: timeSet => {
        state.params = {
          ...state.params,
          startTime:
            timeSet === null || timeSet.length === 0
              ? null
              : dayjs(timeSet[0]).format(state.formatDate),
          endTime:
            timeSet === null || timeSet.length === 0
              ? null
              : dayjs(timeSet[1]).format(state.formatDate)
        }
      },
      changeVisiblePic: () => {
        state.visiblePic = true
        // state.bigPic = bigPic
      },
      handleVisiblePicClose: () => {
        state.visiblePic = false
        // state.bigPic = bigPic
      },
      upload: (info = null, index) => {
        state.fileList = []
        state.info = info
        const { file } = info
        const isLtMaxM = file.size / 1024 <= 20
        if (isLtMaxM) {
          state.uploadHandleChange(index)
        } else {
          message.warning('上传大小不能超过20k!')
          return
        }
      },
      uploadHeaders: {
        Authorization:
          localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
      },
      uploadHandleChange: async () => {
        const { info } = state
        if (info && info.file) {
          const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
          const { success, retInfo, data } = await formRequest(api, {
            file: info.file
          })
          if (success) {
            const { url } = data
            state.langData.imageUrl = url
          } else {
            message.error(retInfo)
          }
        } else {
          message.info('文件未上传！')
        }
      },
      warningAlert: true,
      value: null,
      route: useRoute(),
      router: useRouter(),

      resetParams: () => {
        state.postParams = {}
        state.initDetail()
      },
      deletePeopleGoodsFlag: (params = {}) => {
        let newParams = { ...params }
        delete newParams.peopleGoodsFlag
        return newParams
      },
      formState: {},
      handleReset() {
        state.formState = {}
        state.handleQuery()
      },
      async handleQuery() {
        state.mixPagination.pageNum = 1
        state.getMixList()
      },
      changeRangePicker(date) {
        state.formState.updateTimeBegin = date[0]
        state.formState.updateTimeEnd = date[1]
      },
      initDetail: () => {
        if (state.route.query.terminalId) {
          state.searchParams.terminalId = state.route.query.terminalId - 0
        }
        if (state.route.query.brandId) {
          state.searchParams.brandId = state.route.query.brandId - 0
        }
        if (state.route.query.channelId) {
          state.searchParams.channelId = state.route.query.channelId - 0
        }
        if (state.route.query.siteId) {
          state.searchParams.siteId = state.route.query.siteId - 0
        }
        pdpCountdown_detail_post_(state)
      } // 初始化标题列表
    })
    onMounted(() => {
      if (state.route.query.terminalId) {
        state.searchParams.terminalId = state.route.query.terminalId - 0
      }
      if (state.route.query.brandId) {
        state.searchParams.brandId = state.route.query.brandId - 0
      }
      if (state.route.query.channelId) {
        state.searchParams.channelId = state.route.query.channelId - 0
      }
      if (state.route.query.siteId) {
        state.searchParams.siteId = state.route.query.siteId - 0
        state.router.replace({ query: {} })
      }
      common_querySiteInfo_get_({
        state
      })
    })
    watch(
      () => state.searchParams,
      async () => {
        await state.getLang()
        await common_querySiteInfo_get_({ state })
      },
      {
        deep: true,
        immediate: true
      }
    )
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
.df {
  align-items: center;
  margin-bottom: 20px;
  /* .tar {
    text-align: left;
  } */
}
.sidebarContentBg {
  .hover {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.is-readonly {
  .color-picker-wrap {
    pointer-events: none;
  }
}
</style>

<style>
.subscription .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
</style>
